<template>
    <div class="expand-flex" v-if="shouldBeVisible">
        <div class="expand-flex-main">
            <span class="repeatable-popoutwidget-span">{{ label }}</span>
            <InputWrapper
                :component="widgets.SelectWidget"
                v-for="(value, index) in values"
                :key="name + '-' + index"
                :id="name + '-' + index"
                v-bind="$attrs"
                :name="name"
                :value="value"
                :options="options"
                :required="required"
                colspan="2"
                @input="updateValue(index, $event)"
                @blur="$emit('blur')"
            >
            </InputWrapper>
        </div>
        <!-- FIXME Ändra namn. Förslag är att bara använda default (inget name satt) eller typ "content" -->
        <slot name="whatever"></slot>
        <div class="expand-flex-side" v-if="!preview">
            <div class="side-button-wrapper">
                <button type="button" class="side-button" @click="addNew">
                    <div class="image-wrapper">+</div>
                    Lägg till {{ displayName ? displayName : name }}
                </button>
            </div>
            <div
                class="side-button-wrapper"
                v-for="(value, index) in values"
                :key="name + '-img-' + index"
                :style="index === 0 ? 'display: none' : ''"
            >
                <button type="button" @click="removeItem(index)" class="side-button">
                    <img src="@/assets/delete.svg" />Radera fält
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { inject } from "vue";
    import SelectWidget from "@/components/widgets/inputs/SelectWidget.vue";
    import InputWrapper from "@/components/widgets/inputs/InputWrapper.vue";
    import widgets from "@/components/widgets/inputs";
    import { useStore } from "@/store";

    export default {
        name: "RepeatablePopoutWidget",
        components: {
            SelectWidget,
            InputWrapper,
        },
        setup(props) {
            const configNames = inject("configNames");

            return { configNames };
        },
        props: {
            apisearch: String,
            options: Array,
            name: String,
            value: Array,
            displayName: String,
            preview: Boolean,
            label: String,
            required: Boolean,
        },
        data() {
            return {
                values: this.value && this.value.length ? this.value : [""],
                widgets: widgets,
            };
        },
        computed: {
            shouldBeVisible() {
                const store = useStore();
                return store.getters["config/shouldBeVisibleByName"]({
                    ...(this.configNames ?? {}),
                    name: this.name,
                });
            },
        },
        watch: {
            value(newValue) {
                this.values = newValue && newValue.length ? newValue : [""];
            },
        },
        methods: {
            addNew() {
                this.values.push("");
                this.emitValues();
            },
            removeItem(index) {
                this.values.splice(index, 1);
                this.emitValues();
            },
            updateValue(index, newValue) {
                this.$set(this.values, index, newValue);
                this.emitValues();
            },
            emitValues() {
                this.$emit("input", this.values);
            },
        },
    };
</script>

<style scoped lang="scss">
    $input-height: 70px;
    $error-color: #9e354b;
    .expand-flex {
        display: flex;
        flex-direction: row;

        .repeatable-popoutwidget-span {
            margin-bottom: 0.6rem;
            color: #728296;
            line-height: 21px;
        }
        .k-form-field-display {
            ::v-deep span {
                align-content: center;
                height: 46px;
            }
        }
    }

    .expand-flex-main {
        .error {
            color: $error-color;
        }
        margin-bottom: 0.5rem;
        flex: 1;
        .input-wrapper {
            margin-top: 0.3rem;
            height: $input-height;
            ::v-deep {
                span:not(.error) {
                    display: none;
                }
            }
            margin-bottom: 0;
        }
        .repeatable-popoutwidget-span {
            margin-left: 0.5rem;
        }

        .suggest-wrap {
            margin-bottom: 10px;
        }
    }

    .expand-flex-side {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 1rem;
    }

    .side-button-wrapper {
        display: flex;
        align-items: center;
        height: $input-height;

        .image-wrapper,
        img {
            width: 28px;
            height: 28px;
            line-height: 28px;
        }

        .image-wrapper {
            border-radius: 14px;
            background-color: #38a7cf;
            color: white;
            margin-right: 8px;
        }

        .side-button {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            border: none;
            white-space: nowrap;
            font-family: "Roboto Medium";
            color: black;
            border-radius: 4px;
            background-color: inherit;

            &:disabled {
                background-color: #cccccc;
                cursor: not-allowed;
            }
        }
    }
</style>
